@use "../../styling/buttons.scss" as *;
@use '../../styling/colors.scss' as *;

.SmallLinkButton {
  // This extend picks up the color and styling variants
  @extend %button;

  height: 26px;
  padding: 0;
  min-width: 1px; // to allow button width fit to content size

  a {
    display: inline-flex;
    text-decoration: none !important;
    padding: 4px 8px;
    align-items: center;
    width: 100%;
    justify-content: center;
    column-gap: 6px;
  }

  $button-types: 'primary'$color-white,
    'secondary'$theme-color-text;

  @each $name,
    $color in $button-types {
    &.#{$name} {
      a {
        color: $color !important;
      }
    }
  }

  &.disabled {
    opacity: 0.3;
    pointer-events: none;
  }

  &.text {
    border: 0 !important;
  }

  &.withBackground {
    background-color: $theme-color-secondary-button-background;
  }
}
